export default __webpack_public_path__ + "static/media/banner-homepage.3021c314.jpeg";